import React, { useMemo, useState } from "react";
import { format, isValid, parseISO, isSameDay } from "date-fns";
import CalendarEventMins from "./calendar-event-mins";
import EventPopup from "./event-popup";
import { convertUTCToLocal } from "../../common/constant/constant";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelectedEvent,
} from "../../../reducer/slices/calendercount/calendar-slice";
import useMediaQuery from "../../common/custom-hooks/use-media-query";
const DayView = ({
  currentDate,
  cancelMeeting,
  calOpen,
  setCalOpen,
  setMeetId,
  closePopup,
  setTrialInfo,
  handleCall,
  callCount,
  fetchEvents,
  addToast,
}) => {
  // const [popupPosition, setPopupPosition] = useState(null);
  const [isTooltipVisible, setTooltipVisible] = useState(false);
  const validDate = isValid(currentDate) ? currentDate : new Date();
  const isToday = isSameDay(validDate, new Date());

  const totalCalls =
    callCount.filter((x) => x.date == format(validDate, "yyyy-MM-dd"))?.[0]
      ?.totalCalls || 0;
  const remainingCalls =
    callCount.filter((x) => x.date == format(validDate, "yyyy-MM-dd"))?.[0]
      ?.remainingCalls || 0;
  const calendarData = useSelector((state) => state.calendar);
  const { selectedEvent, allEvents, popupPosition } = useSelector(
    (state) => state.calendar,
  );
  const position = calendarData.popupPosition;
  const dispatch = useDispatch();
  const isMxDesktop = useMediaQuery("(min-width: 2560px)");
  const isSmMxDesktop = useMediaQuery("(min-width: 1920px)");
  const eventsByHour = useMemo(() => {
    const dayKey = format(validDate, "dd MMMM yyyy");
    const map = {};

    allEvents.forEach((event) => {
      const localStart = convertUTCToLocal(event.startTime);

      if (localStart.dateOnly !== dayKey) return;

      const hour = localStart.hours;

      if (!map[hour]) map[hour] = [];

      map[hour].push({
        ...event,
        localStart,
      });
    });

    return map;
  }, [allEvents, validDate]);

  const customStyle =
    !position && position
      ? { display: "none" }
      : {
          left:
            position.left + 450 > window.innerWidth
              ? "auto"
              : position.left + (isMxDesktop ? 50 : isSmMxDesktop ? 0 : 0),
          right: position.left + 500 > window.innerWidth ? "30px" : "auto",
          top:
            position.top + 420 > window.innerHeight
              ? "auto"
              : position.top - 300,
          bottom: position.top + 420 > window.innerHeight ? "30px" : "auto",
          height: "auto",
        };

  return (
    <div className="mt-4 bg-white shadow-md rounded-lg overflow-hidden">
      <div className="grid grid-cols-[80px_1fr] text-center font-bold bg-gray-100 border-b calendar-weekdays-header">
        <div className="border-r table_border"></div>
        {isValid(validDate) ? (
          <div
            className={`text-left p-2 ${isToday ? "blue_color active font-bold" : ""}`}
          >
            <div>
              {/* {format(validDate, "EEEE, MMMM d, yyyy")} */}
              <>
                <span
                  className={`date-big-fonts ${isToday ? "selected_date-big-fonts" : ""}`}
                >
                  {format(validDate, "dd")}
                </span>
                <br />
                <span
                  className={`date-small-fonts ${isToday ? "selected_date-small-fonts" : ""}`}
                >
                  {format(validDate, "EEEE")}
                </span>
              </>
            </div>
            <div className="mt-1">
              <div className="text-xs font-medium mb-1">
                <span className="text-[#1B2A3D] font-[500px]">Total Count</span>
                <span className="ml-3 bg-[#D2E2FF] text-[#4B69E4] py-[2px] px-[4px] rounded font-semibold">
                  {" "}
                  {totalCalls.toString().padStart(2, "0")}{" "}
                </span>
              </div>
              <div className="text-xs font-medium mb-1">
                <span className="text-[#1B2A3D] font-[500px]">
                  {format(validDate, "yyyy-MM-dd") <
                  format(new Date(), "yyyy-MM-dd")
                    ? "Missed Calls"
                    : "Remaining Calls"}
                </span>
                <span className="ml-3 bg-[#FFE3DC] text-[#F27451] py-[2px] px-[4px] rounded font-semibold">
                  {remainingCalls.toString().padStart(2, "0")}{" "}
                </span>
              </div>
            </div>
          </div>
        ) : (
          "Invalid Date"
        )}
      </div>
      <div className="h-[calc(100vh-289px)] overflow-y-auto">
        {[...Array(24)].map((_, i) => {
          const slotEvents = eventsByHour[i] || [];

          return (
            <div
              key={i}
              className="grid grid-cols-[80px_1fr] border-b h-[67px] relative"
            >
              <div className="flex items-center justify-center text-gray-500 text-sm border-r table_border">
                {i}:00
              </div>

              <div className="relative h-full">
                <div className="absolute top-1/2 w-full border-t border-dotted"></div>

                <div className="flex h-full">
                  {slotEvents.map((event) => {
                    const { localStart } = event;
                    const width = `${100 / slotEvents.length}%`;
                    const topOffset = (localStart.minutes / 60) * 67;

                    return (
                      <CalendarEventMins
                        key={event.id}
                        event={event}
                        isTooltipVisible={isTooltipVisible}
                        setTooltipVisible={setTooltipVisible}
                        style={{
                          width,
                          position: "relative",
                          top: `${topOffset}px`,
                        }}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      {selectedEvent && (
        <EventPopup
          setTrialInfo={setTrialInfo}
          closePopup={closePopup}
          cancelMeeting={cancelMeeting}
          onClose={() => dispatch(setSelectedEvent(null))}
          calOpen={calOpen}
          setCalOpen={setCalOpen}
          setMeetId={setMeetId}
          handleCall={handleCall}
          fetchEvents={fetchEvents}
          addToast={addToast}
          customStyle={customStyle}
        />
      )}
    </div>
  );
};

export default DayView;
